<template>
    <div class="container">
        <div class="main-block">
            <div class="store-block" v-if="isLogin">

                <Gift isWeb :isTypeWeb="'loyaltyCard'"/>

            </div>
        </div>

        <!--判斷有無登入-->
        <LoginWeb/>
    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes';
    import Gift from "@/views/gift/Index";
    import LoginWeb from "./components/LoginWeb";

    export default {
        name: "WebStoreLoyaltyCard",
        components: {
            Gift,
            LoginWeb,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
            }
        },
        created() {


        },
        mounted() {



        },
        methods: {

            /** setup */
            setupData: function () {

                // let self = this;
                // if (self.isLogin) {
                //
                // }

            },


        },
    }
</script>
